/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import classes from "./order.module.css";
import DialogContent from "@mui/material/DialogContent";
import Loader from "../../../component/loader";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Draggable from "react-draggable";
import { Paper, Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DialogContentText } from "@mui/material";

// Get order props from parent (Order view page)
const CancelOrderDialog = (props) => {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const t = props.t;

  // Cancel order
  const cancelOrder = async () => {
    setLoading(true);
    if (props.screen && props.screen === "quote") {
      var payload = {};
      var url = `${constants.busV44UrlPublic}/quote/${props.orderId}/updateStatus`;
      var payload = {
        statusId: "QUO_CANCELLED",
      };
      BusApiCall("PUT", url, payload)
        .then((res) => {
          setMsg(t("QUOTE_CANCELLED_SUCCESSFULLY", { props }));
        })
        .catch((err) => {
          setMsg(props.t("DEFAULT_ERROR_MESSAGE"));
        });
    } else {
      BusApiCall("DELETE", `${constants.busV4Url}/orders/${props.orderId}`)
        .then((res) => {
          setLoading(false);
          // setMsg("The Order " + props.orderId + " has been cancelled.")
          setMsg(t("ORDER_CANCELLED_SUCCESSFULLY", { props }));
        })
        .catch((e) => {
          console.log(e);
          setMsg(props.t("DEFAULT_ERROR_MESSAGE"));
        });
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Dialog
        disableScrollLock={true}
        PaperComponent={DraggableDialogPaper}
        classes={{ paper: classes.cancelDialogPaper }}
        fullWidth={true}
        maxWidth={"sm"}
        open={props.isOpen}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {props.screen && props.screen === "quote"
                ? t("CANCEL_QUOTE")
                : t("CANCEL_ORDER")}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => {
                  props.close();
                }}
                onClick={() => {
                  props.close();
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {msg ? (
              msg
            ) : (
              <p>
                {props.screen && props.screen === "quote"
                  ? t("CANCEL_QUOTE_CONFIRMATION", { props })
                  : t("CANCEL_ORDER_CONFIRMATION", { props })}
              </p>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {msg ? (
            <Button
              onClick={() => {
                props.close(true);
              }}
            >
              {t("OK")}
            </Button>
          ) : (
            <React.Fragment>
              <Button
                onClick={() => {
                  props.close();
                }}
              >
                {t("NO")}
              </Button>
              <Button
                onClick={() => {
                  cancelOrder();
                }}
              >
                {t("YES")}
              </Button>
            </React.Fragment>
          )}
        </DialogActions>
      </Dialog>
      <Loader loading={loading} />
    </React.Fragment>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(CancelOrderDialog);
